import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { AssignInspectorAssignmentRequest, InspectorAssignmentODataModel, RightShipInspectionClientModel } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import * as moment from "moment";
import { RightShipInspectionsService } from "../../../../../../services/rightship-inspections/rightship-inspections.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";

@transient()
@autoinject
export class AssignInspectorDialog {

    public inspection: RightShipInspectionClientModel;
    public assignment: InspectorAssignmentODataModel;
    public loading: boolean = false;
    onProceed: () => void;
    onCancel: () => void;

    constructor(private dialogClientService: DialogClientService, private rightsShipInspectionService: RightShipInspectionsService, private notificationClientService: NotificationClientService) {

    }

    activate(model: { inspection: RightShipInspectionClientModel, assignment: InspectorAssignmentODataModel, onProceed: () => Promise<void>, onCancel: () => void })
    {
        this.inspection = model.inspection;
        this.assignment = model.assignment;
        this.onProceed = model.onProceed;
        this.onCancel = model.onCancel;
    }

    close() {
        this.dialogClientService.hide(true);
    }

    async proceed()
    {
        try {
            //trigger loading
            this.loading = true;
            const request: AssignInspectorAssignmentRequest = { 
                inspectionId: this.inspection.id, 
                inspectorAssignmentId: this.assignment.inspectorAssignmentId, 
                inspectorAssignmentFormId: this.assignment.inspectorAssignmentFormId};

            await this.rightsShipInspectionService.assignInspectorAssignment(request);
            
            //terminate loading
            this.loading = false;
            if(this.onProceed)
                this.onProceed();

            this.close();
        } catch (e) {            
            //terminate loading
            this.loading = false; 
            //Add error message
            this.notificationClientService.show("Error", "Assign Inpsector Failed", NotificationType.Error);
        }
    }

    //Get date string
    getDateString(date: Date | string) {
        const dateFormatted = moment(date).format('DD MMM YYYY');

        //check if moment returns invalid date
        if(dateFormatted === 'Invalid date') {
            return null;
        }
        return dateFormatted;
    }    

    cancel()
    {
        if(this.onCancel)
            this.onCancel();

        this.close();
    }
}